// This Userkit of mstage tool will help us to collect user's related data such as:
// Platform information, Profile_ID, ...
// And also send event to event tracking service as well
module.exports = function (window) {

    var messagesRef = '', database;
    var version = 'v1';
    var EventTrackingConfig = {
      token: 'iamarandomshopbacktesttoken',
      eventTrackingUrl: '//tracking.dev.shopback.com/',
      // identityURL: 'http://eventtracker-identity.mstage.io/',
      // apiKey: 'AIzaSyD5t41TtZ7pSvmxcMB2TB6yr_wkx91t5jc',
      // authDomain: 'eventtracker-d09da.firebaseapp.com',
      // databaseURL: 'https://eventtracker-d09da.firebaseio.com',
      // storageBucket: 'eventtracker-d09da.appspot.com',
    };
    var streamingData = {};
    var defaultProp = {};
    var allowedProfileIDType = ['string', 'number'];
    var streamingEvent = {
        STREAM_PLAYING: '_stream_playing',
        STREAM_BUFFER: '_stream_buffer',
        STREAM_LICENSE_RETRIEVED: '_stream_license_retrieved'
    };
    var streamingProperty = {
        TRANSFER_DURATION: '_transfer_duration',
        NUMBER_OF_BYTES_TRANSFERRED: '_number_of_bytes_transferred',
        OBSERVED_BITRATE: '_observed_bitrate',
        AVERAGE_AUDIO_BITRATE: '_average_audio_bitrate',
        AVERAGE_VIDEO_BITRATE: '_average_video_bitrate',
        STARTUP_TIME: '_starup_time',
        DURATION_WATCHED: '_duration_watched',
        NUMBER_OF_DROPPED_VIDEO_FRAMES: '_number_of_dropped_video_frames',
        NUMBER_OF_STALLS: '_number_of_stalls'
    };

    var cookie = {
        write: function (name, value, days, domain, path) {
            var date = new Date();
            days = days || 730; // two years
            path = path || '/';
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = '; expires=' + date.toGMTString();
            var cookieValue = name + '=' + value + expires + '; path=' + path;
            if (domain) {
              if (domain.charAt(0) !== '.') {
                cookieValue += '; domain=.' + domain;
              } else {
                cookieValue += '; domain=' + domain;
              }
            }
            document.cookie = cookieValue;
        },
        read: function (name) {
            var allCookie = '' + document.cookie;
            var index = allCookie.indexOf(name);
            if (name === undefined || name === '' || index === -1) return '';
            var ind1 = allCookie.indexOf(';', index);
            if (ind1 == -1) ind1 = allCookie.length;
            return unescape(allCookie.substring(index + name.length + 1, ind1));
        },
        remove: function (name) {
          if (this.read(name)) {
              this.write(name, '', -1, '/');
          }
        }
    };

    function checkCookie (domain) {
        try {
            // Create cookie
            document.cookie = 'cookietest=1' + (domain ? '; domain=' + domain : '');
            var ret = document.cookie.indexOf('cookietest=') != -1;
            // Delete cookie
            document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT' + (domain ? '; domain=' + domain : '');
            return ret;
        } catch (e) {
            return false;
        }
    };

    function checkLocalStorage () {
       var mod = 'modernizr';
       try {
           localStorage.setItem(mod, mod);
           localStorage.removeItem(mod);
           return true;
       } catch (e) {
           return false;
       }
    };

    function makeRequest (url, data, method, callback) {
        if(window.bootstrapData && window.bootstrapData.environment !== 'production') {
          try{
            console.log(JSON.parse(data));
          } catch(err) {
            console.log('parsing error for data sent')
          }
        }
        if(EventTrackingConfig.token) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function() {
                if (request.readyState == 4 && callback && typeof callback === 'function') {
                    var data = request.responseText;
                    if (data && typeof data === 'string') {
                      data = JSON.parse(data);
                    } else {
                      data = {};
                    }
                    callback({status: request.status, data: data});
                }
            };
            request.open(method, url, true);
            request.setRequestHeader('Content-Type', 'application/json');
            //request.setRequestHeader('X-USERKIT-TOKEN', EventTrackingConfig.token);
            request.send(data);
        }
    };

    function generateProfileID () {
        var text = 'web_';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for ( var i=0; i < 32; i++ ){
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        text += '_' + new Date().getTime();
        return text;
    };

    function mergeObject (obj1,obj2) {
      var obj3 = {};
      for (var attrname in obj1) { obj3[attrname] = obj1[attrname]; }
      for (var attrname in obj2) { obj3[attrname] = obj2[attrname]; }
      return obj3;
    };

    function eventValidate (name, properties) {
      var isValid = true;
      var specificEvents = {
        '_item_viewed': ['_max_length', '_view_length', '_media_type', '_item_id', '_genres', '_show_title'],
        '_item_bookmarked': ['_media_type', '_item_id', '_genres', '_show_title'],
        '_item_favourited': ['_media_type', '_item_id', '_genres', '_show_title'],
        '_item_liked': ['_media_type', '_item_id', '_genres', '_show_title'],
        '_item_rated': ['_item_rated', '_media_type', '_item_id', '_genres', '_show_title']
      };

      if (typeof name !== 'string') {
        console.log('Error: Event name is invalid');
        isValid = false;
      }

      if (isValid && name in specificEvents) {
        if (Object.keys(properties).length === 0) {
          isValid = false;
        } else {
          var requiredProperties = specificEvents[name];
          if (properties['_media_type'] && properties['_media_type'] === 'series') {
            requiredProperties = requiredProperties.concat(['_season_number', '_episode_number', '_episode_title']);
          }
          if (properties['_media_type'] && properties['_media_type'] === 'variety_shows') {
            requiredProperties = requiredProperties.concat(['_episode_number', '_episode_title']);
          }
          if(requiredProperties.length > 0) {
            requiredProperties.forEach(function (p){
              if (!(p in properties)) {
                isValid = false;
              }
            });
          }
        }
      }

      return isValid;
    };

    function parseJWT (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
    };

    function getBrowserInfo () {
      var ua = navigator.userAgent,
          tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
          return {
              name: 'IE',
              version: (tem[1] || '')
          };
      }
      if (M[1] === 'Chrome') {
          tem = ua.match(/\bOPR|Edge\/(\d+)/)
          if (tem != null) {
              return {
                  name: 'Opera',
                  version: tem[1]
              };
          }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
          M.splice(1, 1, tem[1]);
      }
      return {
          name: M[0],
          version: M[1]
      };
    };

    function objectAddPrefix (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (key.charAt(0) !== '_') {
            obj['_' + key] = obj[key];
            delete obj[key];
          }
        }
      }
      return obj;
    };
    
    // window.EventTracker
    return {
        init: function (customConfig) {
            if (customConfig && typeof customConfig === 'object') {
                EventTrackingConfig = mergeObject(EventTrackingConfig, customConfig);
            }
            var EventTracker_defaultInfo = cookie.read('EventTracker_defaultInfo');
            var EventTracker_defaultInfo_notAvailable = !EventTracker_defaultInfo || typeof EventTracker_defaultInfo !== 'string';
            var EventTracker_defaultProp = cookie.read('EventTracker_defaultProp');
            var EventTracker_defaultProp_notAvailable = !EventTracker_defaultProp || typeof EventTracker_defaultProp !== 'string';

            if (!EventTracker_defaultInfo_notAvailable) {
              EventTracker_defaultInfo = JSON.parse(EventTracker_defaultInfo);
            }

            if (!EventTracker_defaultProp_notAvailable) {
              EventTracker_defaultProp = JSON.parse(EventTracker_defaultProp);
            }

            var isOutdatedProps = !!EventTracker_defaultProp._os || !!EventTracker_defaultProp._os;

            if (EventTracker_defaultInfo_notAvailable || isOutdatedProps) {
              var request = new XMLHttpRequest();
              request.onreadystatechange = function() {
                  if (request.readyState == 4) {
                    var response = {
                      as: 'Unknown',
                      countryCode: 'Unknown'
                    };
                    if (request.responseText && typeof request.responseText === 'string') {
                        try {
                          response = JSON.parse(request.responseText);
                        } catch (err) {
                          console.error(err);
                        }
                    }
                    var OSName = 'Unknown';
                    if (navigator.appVersion.indexOf('Win') != -1)
                        OSName = 'Windows';
                    if (navigator.appVersion.indexOf('Mac') != -1)
                        OSName = 'MacOS';
                    if (navigator.appVersion.indexOf('X11') != -1)
                        OSName = 'UNIX';
                    if (navigator.appVersion.indexOf('Linux') != -1)
                        OSName = 'Linux';
    
                    var browserInfo = getBrowserInfo();
    
                    EventTracker_defaultInfo = {
                      os: OSName + '_' + browserInfo.name + '_' + browserInfo.version,
                      country: response.countryCode,
                    }
                    cookie.write('EventTracker_defaultInfo', JSON.stringify(EventTracker_defaultInfo), 1);
    
                    streamingData = {
                      os: 'Web',
                      os_version: EventTracker_defaultInfo.os || 'Unknown',
                      country: EventTracker_defaultInfo.country || 'Unknown',
                    };
                    cookie.write('EventTracker_streamingData', JSON.stringify(streamingData), 1);
    
                    defaultProp = {
                      os: 'Web',
                      os_version: EventTracker_defaultInfo.os || 'Unknown',
                      country: EventTracker_defaultInfo.country || 'Unknown',
                    };
                    cookie.write('EventTracker_defaultProp', JSON.stringify(defaultProp), 1);
                  }
              };
              request.open('GET', 'https://pro.ip-api.com/json/?key=NZiTftaXXjmybB3', true);
              request.send();
            }
    
            var profileID = this.getProfileId();
        },
    
        alias: function (profileID, aliasID, callback) {
          var localProfileID = cookie.read('profileID');
          if (localProfileID && allowedProfileIDType.indexOf(typeof localProfileID) > -1 && profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
            var data = {
                profile_id: localProfileID,
                alias_id: profileID
            };
            if (aliasID && allowedProfileIDType.indexOf(typeof aliasID) > -1) {
                data = {
                    profile_id: profileID,
                    alias_id: aliasID
                };
            }
    
            if (data.profile_id !== data.alias_id) {
                makeRequest(EventTrackingConfig.eventTrackingUrl  + 'client/' + version + '/aliases', JSON.stringify(data), 'POST', callback);
            }
          } else {
            console.trace('Error in EventTracker.alias: Invalid profile id')
          }
        },
    
        getProfileId: function () {
          var profileID = cookie.read('profileID');
          if (profileID) {
            return profileID;
          } else {
            profileID = generateProfileID();
            cookie.write('profileID', profileID, 730);
            cookie.write(profileID, true, 730);
            return profileID;
          }
        },
    
        isLocalProfile: function () {
            var profileID = cookie.read('profileID');
            var isLocalProfile = cookie.read(profileID);
            return isLocalProfile || true;
        },
    
        createNewProfile: function (profileID, properties, callback) {
          if (profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
            if (!properties || typeof properties !== 'object') {
              properties = {};
            }
            var data = {
                profile_id: profileID,
                properties: properties
            };
            makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile', JSON.stringify(data), 'POST', function () {
                cookie.write('profileID', profileID, 730);
                cookie.write(profileID, false, 730);
                if (callback && typeof callback === 'function') {
                    callback();
                } else {
                  console.trace('Created profile successfully!');
                }
            });
          } else {
            console.trace('Error in EventTracker.createNewProfile: Invalid profile id')
          }
        },
    
        identify: function (profileID) {
          if (profileID && allowedProfileIDType.indexOf(typeof profileID) > -1) {
            cookie.write('profileID', profileID, 730);
          } else {
            console.trace('Error in EventTracker.identify: Invalid profile id')
          }
        },
    
        track: function (eventName, properties, callback) {
          var profileID = cookie.read('profileID');
          if (profileID) {
            var isValid = eventValidate(eventName, properties);
            if (isValid) {
              if (!properties || typeof properties !== 'object') {
                properties = {};
              }
              var defaultProp = cookie.read('EventTracker_defaultProp');
              if (defaultProp && typeof defaultProp === 'string') {
                defaultProp = JSON.parse(defaultProp);
              } else {
                defaultProp = {};
              }
              var mergedProp = mergeObject(defaultProp, properties);
              var data = {
                  profile_id: profileID,
                  name: eventName,
                  properties: mergedProp
              };
              makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/events', JSON.stringify(data), 'POST', callback);
            } else {
                console.trace('Error in EventTracker.track: Specific event does not include required properties. Please check again!');
            }
          } else {
            console.trace('Error in EventTracker.track: Invalid profile id')
          }
        },
    
        bulkTrack: function (events, callback) {
          var profileID = cookie.read('profileID');
          if (profileID && events.constructor === Array) {
            var isValid = true;
            events.forEach(function (e) {
              var defaultProp = cookie.read('EventTracker_defaultProp');
              if (defaultProp && typeof defaultProp === 'string') {
                defaultProp = JSON.parse(defaultProp);
              } else {
                defaultProp = {};
              }
              e.properties = mergeObject(defaultProp, e.properties);
              var isEventValid = eventValidate(e.name, e.properties);
              if (!isEventValid) {
                isValid = false;
              }
            });
    
            if (isValid) {
              var data = {
                profile_id: profileID,
                events: events
              };
              makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/events/bulk', JSON.stringify(data), 'POST', callback);
            } else {
              console.trace('Error in EventTracker.bulkTrack: Some of specific events does not include required properties. Please check again!');
            }
          } else {
            console.trace('Error in EventTracker.bulkTrack: Profile ID or Events are invalid')
          }
        },
    
        profile: {
            set: function (properties, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (!properties || typeof properties !== 'object') {
                      properties = {};
                    }
                    var data = {
                        profile_id: profileID,
                        properties: properties
                    };
                    makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile', JSON.stringify(data), 'POST', callback);
                } else {
                  console.trace('Error in EventTracker.profile.set: Invalid profile id')
                }
            },
    
            setOnce: function (properties, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (properties && typeof properties === 'object') {
                      var data = {
                          profile_id: profileID,
                          properties: properties
                      };
                      makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/set_once', JSON.stringify(data), 'PUT', callback);
                    }
                } else {
                  console.trace('Error in EventTracker.profile.setOnce: Invalid profile id')
                }
            },
    
            increase: function (param, number, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (typeof param === 'object' && !number) {
                        // Passing a object
                        var data = {
                            profile_id: profileID,
                            properties: param
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/increase', JSON.stringify(data), 'PUT', callback);
                    } else if (typeof param === 'string') {
                        // Passing a single property
                        var number = number || 1,
                            properties = {};
                        properties[param] = number;
                        var data = {
                            profile_id: profileID,
                            properties: properties
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/increase', JSON.stringify(data), 'PUT', callback);
                    }
                } else {
                  console.trace('Error in EventTracker.profile.increment: Invalid profile id')
                }
            },
    
            append: function (param, value, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (typeof param === 'object' && !value) {
                        var data = {
                            profile_id: profileID,
                            properties: param
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/append', JSON.stringify(data), 'PUT', callback);
                    } else if (typeof param === 'string' && value) {
                        var properties = {};
                        properties[param] = value;
                        var data = {
                            profile_id: profileID,
                            properties: properties
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/append', JSON.stringify(data), 'PUT', callback);
                    }
                } else {
                  console.trace('Error in EventTracker.profile.append: Invalid profile id')
                }
            },
    
            union: function (param, value, callback) {
                var profileID = cookie.read('profileID');
                if (profileID) {
                    if (typeof param === 'object' && !value) {
                        var data = {
                            profile_id: profileID,
                            properties: param
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/union', JSON.stringify(data), 'PUT', callback);
                    } else if (typeof param === 'string' && value) {
                        var properties = {};
                        properties[param] = value;
                        var data = {
                            profile_id: profileID,
                            properties: properties
                        };
                        makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/union', JSON.stringify(data), 'PUT', callback);
                    }
                } else {
                  console.trace('Error in EventTracker.profile.union: Invalid profile id')
                }
            },
    
            getProperty: function (key, callback) {
                var profileID = cookie.read('profileID');
                if (profileID && key && typeof callback === 'function') {
                    makeRequest(EventTrackingConfig.eventTrackingUrl +  'client/' + version + '/profile/property?profile_id=' + profileID + '&key=' + key, null, 'GET', callback);
                } else {
                  console.trace('Error in EventTracker.profile.getProperty: Invalid profile id or callback')
                }
            },
    
            getProperties: function (keys, callback) {
                var profileID = cookie.read('profileID');
                if (profileID && keys && typeof callback === 'function') {
                    makeRequest(EventTrackingConfig.eventTrackingUrl +  'client/' + version + '/profile/properties?profile_id=' + profileID + '&keys=' + keys, null, 'GET', callback);
                } else {
                  console.trace('Error in EventTracker.profile.getProperties: Invalid profile id or callback')
                }
            },
    
            arraySearch: function (key, query, callback) {
              var profileID = cookie.read('profileID');
              if (profileID && typeof key === 'string') {
                var data = {
                    profile_id: profileID,
                    key: key,
                    query: query
                };
                makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/array/search', JSON.stringify(data), 'POST', callback);
              } else {
                console.trace('Error in in EventTracker.profile.arraySearch: Invalid profile id or key')
              }
            },
    
            arrayRemove: function (key, query, callback) {
              var profileID = cookie.read('profileID');
              if (profileID && typeof key === 'string') {
                  var data = {
                      profile_id: profileID,
                      key: key,
                      query: query
                  };
                  makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/profile/array/remove', JSON.stringify(data), 'POST', callback);
              } else {
                console.trace('Error in EventTracker.profile.arrayRemove: Invalid profile id or key')
              }
            },
    
            originalId: function (profileID, callback) {
              if (profileID) {
                makeRequest(EventTrackingConfig. eventTrackingUrl + 'client/' + version + '/profile/original_id?profile_id=' + profileID, null, 'GET', callback);
              } else {
                console.trace('Error in EventTracker.profile.originalId: Invalid profile id');
              }
            }
        },
    
        chat: function (EventTrackingConfig) {
            if (this.isLocalProfile()) {
                console.trace('Error in EventTracker.chat: You need to create a profile before using chat!');
            } else {
              var profileID = cookie.read('profileID');
              firebase.initializeApp(EventTrackingConfig);
    
              // firebase.auth().signInAnonymously().catch(function (error) {
              //     // Handle Errors here.
              //     var errorCode = error.code;
              //     var errorMessage = error.message;
              //     console.trace(errorCode, errorMessage);
              // });
    
              database = firebase.database();
              messagesRef = database.ref('messages/' + profileID);
              messagesRef.off();
    
              function createElement (htmlStr) {
                  var frag = document.createDocumentFragment(),
                      temp = document.createElement('div');
                  temp.innerHTML = htmlStr;
                  while (temp.firstChild) {
                      frag.appendChild(temp.firstChild);
                  }
                  return frag;
              };
    
              function setMessage (data) {
                var message = data.val();
                var messageList = document.getElementById('eventtracker_messageList');
    
                var html = '<div id="message_' + data.key + '" style="';
                if (message.admin) {
                    html += 'display:flex';
                }
                html += '"><div style="';
                if (message.admin) {
                    html += 'background-color:#e7e6ec;'
                }
                html += 'margin:2px 0;padding: 8px 20px;border-radius: 25px;font-family:Tahoma;font-size:11pt;max-width:190px;word-wrap:break-word;';
                if (!message.admin) {
                    html += 'float:right;background-color:#0e86fe;color:#fff;';
                }
                html += '"><span style="font-weight:bold">';
                //if(!message.admin) { html += 'Admin: '; } else { html += 'Me: '; }
                html += '</span>' + message.text + '</div></div>';
                if (!message.admin) {
                    html += '<div style="clear:both;"></div>';
                }
    
                messageList.innerHTML = messageList.innerHTML + html;
                messageList.scrollTop = messageList.scrollHeight;
              };
              setMessage.bind(this);
    
              function deleteMessage(data) {
                  document.getElementById('message_' + data.key).remove();
              };
              deleteMessage.bind(this);
    
              messagesRef.on('child_added', setMessage);
              messagesRef.on('child_removed', deleteMessage);
    
              document.addEventListener('DOMContentLoaded', function() {
                  var textbox = '<div style="bottom:0;position:absolute;width:100%;background-color:#000;""><textarea id="eventtracker_message" style="width:73%;height:24px;font-size:12px;outline:none;margin:5px 10px;border-radius:10px;padding:5px 50px 5px 10px;"></textarea><button id="eventtracker-send" style="position:absolute;bottom:15px;right:12px;padding:5px 10px;border-radius:20px;background-color:#c3a86a;border:none;">SEND</button></div>';
                  var fragment = createElement('<div id="eventtracker-chat-minimize" style="background-color:#ccc;width:300px;height:40px;position:fixed;bottom:0;right:20px;padding:5px 30px;border-radius: 15px 15px 0 0;z-index:999;"><h3 style="line-height:10px">Chat with us!</h3></div><div id="eventtracker-chat-maximize" style="display:none;background-color:#ccc;width:300px;position:fixed;bottom:0;right:20px;padding:5px;border-radius: 15px 15px 0 0;z-index:999;"><div style="background-color:#ccc;height:40px;"><span id="eventtracker-chat-close" style="font-size:14pt;line-height:26pt;float:right;cursor:pointer;margin-right:10pt">Done</span></div><div style="background-color:#fff;height:350px;position:relative"><div id="eventtracker_messageList" style="max-height:300px;overflow:scroll;""></div>' + textbox + '</div></div>');
                  document.body.insertBefore(fragment, document.body.childNodes[0]);
    
                  document.getElementById('eventtracker-chat-minimize').onclick = function(e) {
                      document.getElementById('eventtracker-chat-minimize').style.display = 'none';
                      document.getElementById('eventtracker-chat-maximize').style.display = 'block';
                      var messageList = document.getElementById('eventtracker_messageList');
                      messageList.scrollTop = messageList.scrollHeight;
                  }
                  document.getElementById('eventtracker-chat-close').onclick = function(e) {
                      document.getElementById('eventtracker-chat-maximize').style.display = 'none';
                      document.getElementById('eventtracker-chat-minimize').style.display = 'block';
                  }
                  document.getElementById('eventtracker-send').addEventListener('click', function() {
                      var message = document.getElementById('eventtracker_message');
                      if (message.value) {
                          var date = new Date();
                          var ampm = date.getHours() >= 12
                              ? 'pm'
                              : 'am';
                          var hours = date.getHours();
                          if (hours > 12) {
                              hours -= 12;
                          } else if (hours === 0) {
                              hours = 12;
                          }
                          var currentTime = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ', ' + hours + ':' + date.getMinutes() + ':' + date.getSeconds() + ' ' + ampm;
                          messagesRef.push({text: message.value, admin: false, name: profileID, read: false, createdAt: currentTime}).then(function() {
                              message.value = '';
                          }.bind(this)).catch(function(error) {
                            if (error) {
                              console.error('Error writing new message to Firebase Database', error)
                            }
                          })
                      }
                  });
              });
            }
        },
    
        streamAnalytic: {
            time: function (eventName) {
                var streamingData = cookie.read('EventTracker_streamingData');
                if (streamingData) {
                    if (typeof streamingData === 'string') {
                      streamingData = JSON.parse(streamingData);
                    } else {
                      streamingData = {};
                    }
                    if (eventName in streamingEvent) {
                        var data = streamingData;
                        data['_duration'] = new Date().getTime();
                        cookie.write(streamingEvent[eventName], JSON.stringify(data), 730);
                    } else {
                        console.trace('Error in EventTracker.streamAnalytic.track: Event name does not support!');
                    }
                } else {
                    console.trace('You need to call the init function first!');
                }
            },
    
            track: function (eventName, callback) {
                var streamingData = cookie.read('EventTracker_streamingData');
                if (streamingData) {
                    if (typeof streamingData === 'string') {
                      streamingData = JSON.parse(streamingData);
                    } else {
                      streamingData = {};
                    }
                    var profileID = cookie.read('profileID');
                    if (profileID) {
                        if (eventName in streamingEvent) {
                            var event = cookie.read(streamingEvent[eventName]);
                            if (event && typeof event === 'string') {
                                event = JSON.parse(event);
                            }
                            if (!event || typeof event !== 'object') {
                                console.trace('Error in streamAnalytic.track: Event does not exist');
                            } else {
                                event['_duration'] = new Date().getTime() - event['_duration'];
                                var defaultProp = cookie.read('EventTracker_defaultProp');
                                if (defaultProp && typeof defaultProp === 'string') {
                                    defaultProp = JSON.parse(defaultProp);
                                } else {
                                    defaultProp = {};
                                }
                                var mergedProp = mergeObject(defaultProp, event);
                                var data = {
                                    profileID: profileID,
                                    name: streamingEvent[eventName],
                                    properties: mergedProp
                                };
                                makeRequest( EventTrackingConfig.eventTrackingUrl + 'client/' + version + '/events', JSON.stringify(data), 'POST', callback);
                            }
                        } else {
                            console.trace('Error in EventTracker.streamAnalytic.track: Event name does not support!');
                        }
                    } else {
                      console.trace('Error in EventTracker.streamAnalytic.track: Invalid profile id')
                    }
                } else {
                    console.trace('You need to call the init function first!');
                }
            },
    
            set: function (eventName, propertyName, value) {
                var streamingData = cookie.read('EventTracker_streamingData');
                if (streamingData) {
                    if (typeof streamingData === 'string') {
                      streamingData = JSON.parse(streamingData);
                    } else {
                      streamingData = {};
                    }
                    if (eventName in streamingEvent) {
                        var event = cookie.read(streamingEvent[eventName]);
                        if (event && typeof event === 'string') {
                            event = JSON.parse(event);
                        }
                        if (!event || typeof event !== 'object') {
                            console.trace('Error in EventTracker.streamAnalytic.set: Event does not exist');
                        } else {
                            if (propertyName in streamingProperty) {
                                if (propertyName === 'NUMBER_OF_BYTES_TRANSFERRED'){
                                  value = (value / 1000000) * 8;
                                } else if (propertyName === 'OBSERVED_BITRATE' || propertyName === 'AVERAGE_AUDIO_BITRATE' || propertyName === 'AVERAGE_VIDEO_BITRATE'){
                                  value = value / 1000000;
                                }
                                event[streamingProperty[propertyName]] = value;
                                cookie.write(streamingEvent[eventName], JSON.stringify(event), 730);
                            } else {
                                console.trace('Error in EventTracker.streamAnalytic.set: Property name does not support!');
                            }
                        }
                    } else {
                        console.trace('Error in EventTracker.streamAnalytic.set: Event name does not support!');
                    }
                } else {
                    console.trace('You need to call the init function first!');
                }
            }
        },
    
        getLocationInfo: function () {
          var EventTracker_defaultInfo = cookie.read('EventTracker_defaultInfo');
          if (EventTracker_defaultInfo && typeof EventTracker_defaultInfo === 'string') {
            EventTracker_defaultInfo = JSON.parse(EventTracker_defaultInfo);
          } else {
            EventTracker_defaultInfo = {
              country: ''
            };
          }
    
          return EventTracker_defaultInfo.country;
        }
    
    }
};
